import { InlandModeOfTransportType } from "../../../../../../api/types/generated-types";

const mapInlandModesToCopy = {
  [InlandModeOfTransportType.OverTheRoad]: "Over the road",
  [InlandModeOfTransportType.Rail]: "Rail",
};

export default mapInlandModesToCopy;
